export default {
  subtitle:
    "In-depth analysis of EU CBAM carbon compliance to help SMEs quickly understand regulations and market trends",
  feature1: "CBAM Introduction",
  feature2: "Compliance Process",
  feature3: "Market Trends",
  feature4: "How Our Product Helps Businesses",
  seo_title: "EU CBAM Carbon Compliance Guide",
  section1_title: "CBAM Introduction",
  section1_content1:
    "The European Union Carbon Border Adjustment Mechanism (CBAM) is an important policy tool introduced by the EU to address climate change.",
  section1_content2:
    "This mechanism aims to prevent carbon leakage and ensure that imported goods are in a fair competitive environment with goods produced within the EU in terms of carbon emission costs.",
  section1_content3:
    "CBAM requires importers of specific high-carbon-emission goods into the EU to purchase corresponding carbon emission allowances equivalent to the carbon costs borne by EU domestic producers.",
  section2_title: "Compliance Process",
  section2_content: "CBAM compliance process includes four key steps:",
  section2_step1:
    "Declaration: Importers need to register in the CBAM system and regularly declare the carbon emissions of imported goods",
  section2_step2:
    "Verification: The declared carbon emission data needs to be verified by a third-party verification agency",
  section2_step3:
    "Purchase of Allowances: Purchase the corresponding CBAM certificates based on the verified carbon emissions",
  section2_step4:
    "Customs Clearance: Goods can be cleared for entry into the EU market after completing the purchase of CBAM certificates",
  section3_title: "Market Trends",
  section3_content: "CBAM is continuously evolving and developing, with major trends including:",
  section3_trend1:
    "Expanding Scope: CBAM will gradually expand to more industries, including organic chemicals and plastic products",
  section3_trend2:
    "Stricter Standards: The EU will continue to improve the accuracy and transparency requirements for carbon emission accounting",
  section3_trend3:
    "Global Impact: CBAM is driving global trading partners to establish or adjust their own carbon pricing mechanisms",
  section3_trend4:
    "Technology Development: Digital tools and automated systems are playing an increasingly important role in carbon emission accounting",
  section4_title: "How Our Product Helps Businesses",
  section4_content:
    "Our product can help businesses efficiently address CBAM compliance requirements:",
  section4_benefit1:
    "Accurate Calculation: Provides accurate carbon emission calculations based on EU official factors and custom factors",
  section4_benefit2:
    "Efficient Compliance: Automatically generates CBAM-compliant reports, simplifying the declaration process",
  section4_benefit3:
    "Batch Processing: Supports large-volume data processing to improve work efficiency",
  section4_benefit4:
    "API Integration: Easily integrates with ERP and e-commerce systems to achieve automated compliance reporting",
  download_title: "Download Whitepaper Now",
  email_placeholder: "Please enter your email",
  agreement_text:
    "I agree to use this email to receive the whitepaper and agree to process my personal data according to GDPR requirements.",
  privacy_policy: "View Privacy Policy",
  download_button: "Download Whitepaper (PDF)",
  download_generating: "Generating...",
  email_required: "Please enter your email",
  agreement_required: "Please agree to the privacy policy",
  download_success: "Whitepaper downloaded successfully, thank you for using our service!",
  download_failed: "Download failed, please try again later",
  submit_error: "Submission failed, please try again later",
};
